export function generateUniqueIdWithIdPrefix(prefix: string = 'id-') {
  return `${prefix}${crypto.randomUUID()}`;
}
